import { store } from 'store';
import { useSelector } from 'react-redux';
import React, { useState, Fragment, useEffect } from 'react';


import { formatAccountCategoriesData } from 'utils/helpers';
import { bankTransactionsMakeStyles } from '../style/style';
import UnimportedTransactions from './UnimportedTransactions';

const BankTransactionsStack = ({ selectedBank }) => {
    const classes = bankTransactionsMakeStyles({});
    const { data: companyData } = useSelector((state) => state?.company);

    const [coaCategoryData, setCoaCategoryData] = useState({
        title: 'Select',
        children: [],
        loading: true,
    });
    const [selectedTab, setSelectedTab] = useState('Not imported');

    return (
        <Fragment>
            {selectedTab === 'Not imported' && (
                <UnimportedTransactions
                    selectedBank={selectedBank}
                    coaCategoryData={coaCategoryData}
                />
            )}
        </Fragment>
    );
};

export default BankTransactionsStack;
